'use strict';

import {SectionCtrl} from "./sectionctrl.js";
import {sectionModel} from "../../models/sectionmodel.js";

export class SectionB3ImpactCtrl extends SectionCtrl
{
	text = {
		before: {
			key: 'b3_impact_before',
			on: false,
			value: null
		},
		after: {
			key: 'b3_impact_after',
			on: false,
			value: null
		}
	};
	
	constructor($scope, $filter, jsDataService){
		super($scope, $filter, jsDataService);
		if(typeof(this.section.childs) !== 'undefined'){
			this.initChildSections(this.section.childs);
		}
	}
	
	$onInit(){
		if(typeof(this.section.instructions) !== 'undefined'){
			for(let prop in this.text){
				if(typeof(this.section.instructions[this.text[prop].key]) !== 'undefined' && this.section.instructions[this.text[prop].key].value !== ''){
					this.text[prop].on = true;
					this.text[prop].value = this.section.instructions[this.text[prop].key].value;
				}
			}
		}
	}
	
	autosavePostFields(){
		let post = [];
		
		for(let section in this.childSections){
			if(this.childSections[section] instanceof sectionModel){
				for(let fkey in this.childSections[section].fieldMap){
					post.push(this.childSections[section].fieldMap[fkey].getData());
				}
			}
		}
		return post;
	}
}

